import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from './CartContext';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './enquiry.css';

const EnquiryForm = () => {
  const { cartItems, setCartItems } = useCart();
  const navigate = useNavigate();
  const [status, setStatus] = useState('idle');
  const [form, setForm] = useState({ user_name: '', user_email: '', user_phone: '', message: '' });

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (cartItems.length === 0) {
      toast.warn("Your cart is empty!");
      return;
    }

    setStatus('sending');
    const toastId = toast.loading("Sending enquiry...");

    const cartPayload = cartItems.map(item => ({
      name: item.name,
      quantity: item.qtyCount,
      type: item.qtyType || 'Standard',
      price: item.price || 0
    }));

    try {
      const response = await fetch('/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: form.user_name,
          email: form.user_email,
          phone: form.user_phone,
          message: form.message,
          cart: cartPayload
        }),
      });

      const result = await response.json();

      if (response.ok) {
        toast.update(toastId, { render: "Enquiry Sent!", type: "success", isLoading: false, autoClose: 3000 });
        setCartItems([]); // Clear cart
        setTimeout(() => navigate('/order-confirmed'), 2000);
      } else {
        throw new Error(result.error || "Server error");
      }
    } catch (error) {
      console.error(error);
      setStatus('error');
      toast.update(toastId, { render: "Failed to send.", type: "error", isLoading: false, autoClose: 3000 });
    }
  };

  return (
    <div className="enquiry-wrapper">
      <ToastContainer position="top-center" />
      <form className="enquiry-form" onSubmit={handleSubmit}>
        <button className="back-to-cart" type="button" onClick={() => navigate('/cart')}>⟵ Back to Cart</button>
        <div className="enquirecontainer">
          <h2>Enquiry Form</h2>
          <div style={{ background: '#e3f2fd', padding: '10px', borderRadius: '5px', marginBottom: '15px', color: '#0d47a1' }}>
            🛒 <strong>{cartItems.length} items</strong> attached.
          </div>
          <div className="section-title">Contact Info</div>
          <input type="text" name="user_name" placeholder="Name" value={form.user_name} onChange={handleChange} required />
          <input type="email" name="user_email" placeholder="Email" value={form.user_email} onChange={handleChange} required />
          <input type="tel" name="user_phone" placeholder="Phone" value={form.user_phone} onChange={handleChange} required />
          <textarea name="message" placeholder="Message" value={form.message} onChange={handleChange}></textarea>
          <button type="submit" disabled={status === 'sending' || cartItems.length === 0}>
            {status === 'sending' ? 'Sending...' : 'Submit Enquiry'}
          </button>
        </div>
      </form>
    </div>
  );
};
export default EnquiryForm;
